import { useContext } from "react";
import { CurrentUser } from "lib/definitions";
import { createContext } from 'react';

export interface CurrentUserStore {
  currentUser: CurrentUser,
  changeCurrentUser(currentUser: CurrentUser): void,
  guestUser?: {
    id: number;
  }
}

export const CurrentUserContext = createContext<CurrentUserStore | undefined>(undefined);

export function useCurrentUser() {
  return useContext<CurrentUserStore>(CurrentUserContext);
}
